const demo_app = {
    title: 'คุณได้ลงชื่อเข้าใช้การแสดงตัวอย่างแบบสดสำเร็จแล้ว!',
    subtitle: 'นี่คือข้อมูลผู้ใช้ของคุณ:',
    username: 'ชื่อผู้ใช้: ',
    user_id: 'รหัสผู้ใช้: ',
    sign_out: 'ออกจากการแสดงตัวอย่างแบบสด',
    continue_explore: 'หรือสำรวจต่อ',
    customize_sign_in_experience: 'ปรับแต่งประสบการณ์การลงชื่อเข้าใช้',
    enable_passwordless: 'เปิดใช้งานแบบไม่ใช้รหัสผ่าน',
    add_social_connector: 'เพิ่มตัวเชื่อมต่อโซเชียล',
};
export default Object.freeze(demo_app);
